module.exports = __webpack_public_path__ + "img/kejiguan.eac4e0f1.png";